import { render } from "./FavoritesCard.vue?vue&type=template&id=e0e88c8a"
import script from "./FavoritesCard.vue?vue&type=script&lang=js"
export * from "./FavoritesCard.vue?vue&type=script&lang=js"

import "./FavoritesCard.vue?vue&type=style&index=0&id=e0e88c8a&lang=css"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/dynamik_webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__